import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
} from '@mui/material';
import { listFamilyMembers } from '../../services/familyManagementService';
import { useAuth } from '../../contexts/AuthContext';

const SponsorFamilyModal = ({ open, onClose, sponsor }) => {
  const { profile } = useAuth();
  const [familyMembers, setFamilyMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFamilyMembers = async () => {
      if (!open || !sponsor || !profile?.tenant_id) return;
      setLoading(true);
      setError(null);
      try {
        const { data, error } = await listFamilyMembers({
          tenantId: profile.tenant_id,
          sponsorId: sponsor.id,
        });
        if (error) throw error;
        setFamilyMembers(data);
      } catch (err) {
        setError('Failed to load family members.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFamilyMembers();
  }, [open, sponsor, profile?.tenant_id]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Family Members Sponsored by {sponsor?.first_name} {sponsor?.last_name}
      </DialogTitle>
      <DialogContent>
        {loading && <Typography>Loading...</Typography>}
        {error && <Alert severity="error">{error}</Alert>}
        {!loading && !error && familyMembers.length === 0 && (
          <Typography sx={{ mt: 2 }}>No family members found for this sponsor.</Typography>
        )}
        {!loading && !error && familyMembers.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {familyMembers.map((member) => (
                  <TableRow key={member.id}>
                    <TableCell>{`${member.first_name} ${member.last_name}`}</TableCell>
                    <TableCell>{member.email}</TableCell>
                    <TableCell>
                      <Chip label={member.status} size="small" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SponsorFamilyModal;
